import is from './is';
import { vttToJson } from './search-vtt';
export default function cacheCues(player) {
  // Bail is search is not enabled.
  if (!player?.config.preset?.search?.enabled) return;
  // Bail if no language tracks are added.
  if (!player?.media?.textTracks?.length || player?.media?.textTracks?.length === 0) return;
  // Bail if already a track is selected by the user.
  if (player?.currentTrack !== -1) return;

  // Cache the default 1st available track.
  player.toggleCaptions(true);

  let interval = setInterval(() => {
    const generatedCues = player.media.textTracks[0]?.cues;

    if (generatedCues?.length > 0) {
      // Cache it into localstorage.
      setCues(player);
      // Reset to original track.
      player.toggleCaptions(false);

      clearInterval(interval);
    }
  }, 200);
}

export function getCues(player) {
  if (!player) return;
  const locallyStoredCues = localStorage.getItem('presto-player-' + player.id + '-cues');

  if (is.empty(locallyStoredCues)) return '';

  return JSON.parse(locallyStoredCues);
}

export function setCues(player) {
  if (
    !player ||
    !player?.media?.textTracks ||
    player?.media?.textTracks?.length === 0
  ) return;
  
  const cues = (player?.media?.textTracks?.[0]) ? vttToJson(player.media.textTracks[0]) : {};
  if ( !is.empty(cues) ) {
    localStorage.setItem('presto-player-' + player.id + '-cues', JSON.stringify(cues));
  }
  
}
